module.exports = __webpack_public_path__ + "static/media/sergio.4504ca51.jpg";